import React from 'react'

import img3 from '../assets/profile.jpg'

import { MdOutlineWork } from "react-icons/md";
import { ImHome } from "react-icons/im";
import { IoMail } from "react-icons/io5";
import { IoCall } from "react-icons/io5";

import { FaAsterisk } from "react-icons/fa";

import { GrLanguage } from "react-icons/gr";

import { FaSuitcase } from "react-icons/fa";
import { TiStarburst } from "react-icons/ti";
import { LuCalendarDays } from "react-icons/lu";

import AnimatedContent from '../reactbits/AnimatedContent';

import { Helmet } from "react-helmet";



import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

export default function Resume() {




    return (
        <div>
            <h1 style={{ display: 'none' }}>Bikram | MERN Stack Developer Resume</h1><br />
            <p style={{ display: 'none' }}>
                Explore the resume of Bikram, a passionate MERN Stack Developer with experience in MongoDB, Express, React, and Node.js. Find education, work experience, and technical skills.
            </p>

            <Helmet>
                <title>Resume | Bikram Portfolio</title>
                <meta
                    name="description"
                    content="Explore Bikram's professional resume, skills, and experience."
                />
                <link rel="canonical" href="https://www.bikramportfolio.ooguy.com/resume" />

                <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is Bikram's tech stack?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Bikram is a MERN stack developer experienced in MongoDB, Express.js, React.js, and Node.js."
          }
        },
        {
          "@type": "Question",
          "name": "Is Bikram available for freelance projects?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Bikram is open to freelance opportunities in full-stack web development."
          }
        }
      ]
    }
    `}
  </script>
            </Helmet>


            <AnimatedContent
                distance={150}
                direction="horizontal"
                reverse={false}
                config={{ tension: 80, friction: 20 }}
                initialOpacity={0.2}
                animateOpacity
                scale={1.1}
                threshold={0.2}
            >





                <div className="w-[95%] mx-auto sm:w-[97%] sm:mx-auto ml-7 ">

                    <div className=" sm:flex sm:justify-start sm:items-center sm:space-x-4 ">


                        <div className="w-[100%] sm:w-[35%] h-[1500px] shadow-md shadow-slate-600 ">


                            <div
                                data-aos="zoom-in"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-mirror="true"
                                data-aos-once="false"
                                data-aos-anchor-placement="top-center"
                                className="w-[100%] h-[400px] bg-slate-300 relative"
                            >
                                <img
                                    className="w-[100%] h-[400px] object-cover absolute"
                                    src={img3}
                                    alt="profile"
                                />

                                <h1 className="sm:text-3xl absolute mt-[330px] ml-4 text-black sm:font-bold">
                                    Topher Atticus
                                </h1>
                            </div>


                            <div className="w-[100%] h-[300px]  border-black mt-2 ">
                                <div className="w-[90%] sm:w-[95%] h-[70px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5 cursor-pointer
                            hover:bg-slate-300 "><MdOutlineWork />  <span className=' sm:text-lg'>Designer</span></div>
                                <div className="w-[90%] sm:w-[95%] h-[75px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5 cursor-pointer
                            hover:bg-slate-300"><ImHome />  <span className='sm:text-lg'>London, UK</span></div>
                                <div className="w-[90%] sm:w-[95%] h-[75px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5 cursor-pointer
                            hover:bg-slate-300"><IoMail />  <span className='sm:text-lg'>ex@mail.com</span></div>
                                <div className="w-[90%] sm:w-[95%] h-[75px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5 cursor-pointer
                            hover:bg-slate-300"><IoCall />  <span className='sm:text-lg'>1224435534</span></div>
                                <div className=" w-[95%] flex justify-start ml-4 border-b-2 border-green-600 "></div>


                            </div>

                            <div data-aos="zoom-in"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-mirror="true"
                                data-aos-once="false"
                                data-aos-anchor-placement="top-center"

                                className="w-[100%] h-[400px]">

                                <div className="w-[100%] h-[92px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><FaAsterisk /><span className='sm:text-xl text-black'>Skills</span></div>

                                <div className="w-[100%] h-[38px] flex justify-start text-green-800 sm:text-lg ml-4">MongoDb</div>
                                <div className="w-[100%] h-[38px]">
                                    <div className="w-[93%] h-[20px] flex justify-start items-center bg-slate-300 ml-4 rounded-full animate-pulse">
                                        <div className="w-[90%] h-[20px] flex justify-start items-center bg-green-500 rounded-full"><span className=' w-[100%] text-white '>90%</span></div>
                                    </div>
                                </div>

                                <div className="w-[100%] h-[38px] flex justify-start text-green-800 sm:text-lg ml-4">Express</div>
                                <div className="w-[100%] h-[38px]">
                                    <div className="w-[93%] h-[20px] flex justify-start items-center bg-slate-300 ml-4 rounded-full animate-pulse">
                                        <div className="w-[80%] h-[20px] flex justify-start items-center bg-green-500 rounded-full"><span className=' w-[100%] text-white '>80%</span></div>
                                    </div>
                                </div>

                                <div className="w-[100%] h-[38px] flex justify-start text-green-800 sm:text-lg ml-4">React</div>
                                <div className="w-[100%] h-[38px]">
                                    <div className="w-[93%] h-[20px] flex justify-start items-center bg-slate-300 ml-4 rounded-full animate-pulse">
                                        <div className="w-[75%] h-[20px] flex justify-start items-center bg-green-500 rounded-full"><span className=' w-[100%] text-white '>75%</span></div>
                                    </div>
                                </div>

                                <div className="w-[100%] h-[38px] flex justify-start text-green-800 sm:text-lg ml-4">Node</div>
                                <div className="w-[100%] h-[38px]">
                                    <div className="w-[93%] h-[20px] flex justify-start items-center bg-slate-300 ml-4 rounded-full animate-pulse">
                                        <div className="w-[50%] h-[20px] flex justify-start items-center bg-green-500 rounded-full"><span className=' w-[100%] text-white '>50%</span></div>
                                    </div>
                                </div>
                                <div className=" w-[95%] flex justify-start ml-4 border-b-2 border-green-600 "></div>


                            </div>

                            <div className="w-[100%] h-[400px]">

                                <div className="w-[100%] h-[130px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><GrLanguage /><span className='sm:text-xl text-black'>Languages</span></div>

                                <div className="w-[100%] h-[44px] flex justify-start text-green-800 sm:text-lg ml-4">English</div>
                                <div className="w-[100%] h-[44px]">
                                    <div className="w-[93%] h-[20px] flex justify-start items-center bg-slate-300 ml-4 rounded-full animate-pulse">
                                        <div className="w-[90%] h-[20px] flex justify-start items-center bg-green-500 rounded-full"><span className=' w-[100%] text-white '>90%</span></div>
                                    </div>
                                </div>

                                <div className="w-[100%] h-[44px] flex justify-start text-green-800 sm:text-lg ml-4">Spanish</div>
                                <div className="w-[100%] h-[44px]">
                                    <div className="w-[93%] h-[20px] flex justify-start items-center bg-slate-300 ml-4 rounded-full animate-pulse">
                                        <div className="w-[80%] h-[20px] flex justify-start items-center bg-green-500 rounded-full"><span className=' w-[100%] text-white '>80%</span></div>
                                    </div>
                                </div>

                                <div className="w-[100%] h-[44px] flex justify-start text-green-800 sm:text-lg ml-4">German</div>
                                <div className="w-[100%] h-[44px]">
                                    <div className="w-[93%] h-[20px] flex justify-start items-center bg-slate-300 ml-4 rounded-full animate-pulse">
                                        <div className="w-[75%] h-[20px] flex justify-start items-center bg-green-500 rounded-full"><span className=' w-[100%] text-white '>75%</span></div>
                                    </div>
                                </div>



                            </div>
                        </div>




                        <div className="w-[100%] mt-6 sm:w-[65%] space-y-4 sm:ml-7 sm:mt-0 ">

                            <div data-aos="zoom-in"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-mirror="true"
                                data-aos-once="false"
                                data-aos-anchor-placement="top-center"

                                className=" w-[100%] h-[900px]  shadow-md shadow-slate-600 duration-300 cursor-pointer hover:bg-slate-300  ">
                                <div className="w-[100%] h-[150px]  ">
                                    <div className="w-[100%] h-[130px] flex justify-start items-center text-green-800 sm:text-3xl ml-4 space-x-5"><FaSuitcase /><span className='sm:text-3xl text-black'>Work Experience</span></div>
                                </div>


                                <div className="w-[100%] h-[250px] ">
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-2xl text-black font-semibold'>Front End Developer / w3schools.com</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><LuCalendarDays /><span className='sm:text-xl text-green-800'>Jan 2015 - Current</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-xl text-black'>Lorem ipsum dolor sit amet. </span></div>
                                    <div className=" w-[95%] flex justify-start ml-4 border-b-2 border-green-600 "></div>

                                </div>


                                <div className="w-[100%] h-[250px]  ">
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-2xl text-black font-semibold'>Web Developer / something.com</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><LuCalendarDays /><span className='sm:text-xl text-green-800'>Mar 2012 - Dec 2014</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-xl text-black'>Consectetur adipisicing elit. Praesentium magnam </span></div>
                                    <div className=" w-[95%] flex justify-start ml-4 border-b-2 border-green-600 "></div>
                                </div>


                                <div className="w-[100%] h-[250px]  ">
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-2xl text-black font-semibold'>Graphic Designer / designsomething.com</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><LuCalendarDays /><span className='sm:text-xl text-green-800'>Jun 2010 - Mar 2012</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-xl text-black'>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</span></div>

                                </div>
                            </div>



                            <div

                                className=" w-[100%] h-[585px] shadow-md shadow-slate-600 duration-300 cursor-pointer hover:bg-slate-300  ">


                                <div className="w-[100%] h-[135px]">
                                    <div className="w-[100%] h-[130px] flex justify-start items-center text-green-800 sm:text-4xl ml-4 space-x-5"><TiStarburst /><span className='sm:text-4xl text-black'>Education</span></div>

                                </div>

                                <div className="w-[100%] h-[150px] ">
                                    <div className="w-[100%] h-[40px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-2xl text-black font-semibold'>W3Schools.com</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><LuCalendarDays /><span className='sm:text-xl text-green-800'>Forever</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-xl text-black'>Web Development! All I need to know in one place</span></div>
                                    <div className=" w-[95%] flex justify-start ml-4 border-b-2 border-green-600 "></div>
                                </div>

                                <div className="w-[100%] h-[150px] ">
                                    <div className="w-[100%] h-[40px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-2xl text-black font-semibold'>London Business School</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><LuCalendarDays /><span className='sm:text-xl text-green-800'>2013 - 2015</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-xl text-black'>Master Degree</span></div>
                                    <div className=" w-[95%] flex justify-start ml-4 border-b-2 border-green-600 "></div>
                                </div>

                                <div className="w-[100%] h-[150px] ">
                                    <div className="w-[100%] h-[40px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-2xl text-black font-semibold'>School of Coding</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><LuCalendarDays /><span className='sm:text-xl text-green-800'>2010 - 2013</span></div>
                                    <div className="w-[100%] h-[50px] flex justify-start items-center text-green-800 sm:text-2xl ml-4 space-x-5"><span className='sm:text-xl text-black'>Bachelor Degree</span></div>

                                </div>

                            </div>

                        </div>
                    </div>


                </div>







            </AnimatedContent>




        </div>
    )
}
